import React from 'react';
import { Result } from 'antd';
import { Link } from 'react-router-dom';

/**
 * Shown instead of a CampusCloud page that needs a table the TVET campus databases do not have.
 * The feature list and the reasoning live in src/misc/TvetTenant.js; this file only renders it.
 */
export function TvetFeatureUnavailable({ feature }) {
   if (!feature) {
      return null;
   }

   const tables = feature.tables.join(', ');

   return (
      <Result
         status="info"
         title={feature.title}
         subTitle={(
            <>
               This page reads <code>{tables}</code>, which does not exist in the TVET campus schema.
               The TVET overlay did not port this feature, so it is hidden here rather than failing
               halfway through loading. Ask the CampusCloud administrator if the TVET campus needs it.
            </>
         )}
         extra={<Link to="/home">Back to dashboard</Link>}
      />
   );
}

export default TvetFeatureUnavailable;
